import { IconSvgProps } from '../types';
export const Rocket = ({ size }: IconSvgProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 32 33"
		fill="none"
		id="icon-rocket"
		width={size}
		height={size}
		version="1.1"
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.1933 16.3702L13.3067 14.2568L11.1933 12.1435L12.9567 10.3802H17.1867L20.36 7.20685H25.2933V12.1402L22.12 15.3135V19.5435L20.3567 21.3068L18.2433 19.1935L16.13 21.3068L14.1933 19.3702L16.5133 17.0502L15.4567 15.9935L13.1367 18.3135L11.1967 16.3735L11.1933 16.3702ZM22.8233 11.4368C22.3367 11.9235 21.5467 11.9235 21.06 11.4368C20.5733 10.9502 20.5733 10.1602 21.06 9.67351C21.5467 9.18685 22.3367 9.18685 22.8233 9.67351C23.31 10.1602 23.31 10.9502 22.8233 11.4368Z"
			fill="#1868DB"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.8133 22.2068C14.69 24.3302 11.7067 25.7535 6.75333 25.6468C6.64333 20.6935 8.06667 17.7135 10.1933 15.5868C12.14 13.6402 15.17 13.2202 18.2233 14.1735C19.1767 17.2268 18.76 20.2568 16.81 22.2035L16.8133 22.2068Z"
			fill="#FCA700"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.4367 19.3802L18.2467 19.1902L16.13 21.3035L14.1933 19.3669L16.5133 17.0469L15.4567 15.9902L13.1367 18.3102L11.1967 16.3702L13.31 14.2535L13.02 13.9635C14.5967 13.5235 16.4067 13.6069 18.2267 14.1735C18.7933 15.9935 18.8767 17.8035 18.4367 19.3802Z"
			fill="#09326C"
		/>
	</svg>
);
